import axios from 'axios';

// Configurer l'instance Axios
const api = axios.create({
  baseURL: 'API_URLS /api/', // URL de base
  withCredentials: true, // Inclure les cookies dans les requêtes
  headers: {
    'Content-Type': 'application/json',
  },
});

// Méthode pour récupérer les cours
// export const getCourses = async () => {
//   try {
//     const response = await api.get('/courses');
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la récupération des cours:', error);
//     throw error;
//   }
// };

// // Méthode pour récupérer les témoignages
// export const getTestimonials = async () => {
//   try {
//     const response = await api.get('/testimonials');
//     return response.data;
//   } catch (error) {
//     console.error('Erreur lors de la récupération des témoignages:', error);
//     throw error;
//   }
// };

// Méthode pour envoyer un message de contact
export const sendContactMessage = async (formData, user = null) => {
  try {
    const data = {
      ...formData,
      user_id: user ? user.id : null,
    };

    const response = await api.post('/contact-messages', data);
    if (response.status === 201) {
      console.log('✅ Message envoyé avec succès:', response.data);
      return response.data;
    } else {
      console.error('❌ Erreur lors de l\'envoi du message:', response.statusText);
      throw new Error('Erreur lors de l\'envoi du message');
    }
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi du message de contact:', error.response?.data || error.message);
    throw error;
  }
};
